import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as Logger from "js-logger";
import * as Store from "../../store";

import Basket from "../../components/basket";
import template from "./basket.vue";
import Product from "../../models/Product";

@Component({
  mixins: [template],
  components: {
    Basket: Basket
  }
})
export default class BasketView extends Vue {
  get products(): Array<Product> {
    return Store.readBasket(this.$store);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/layouts/Basket/index.ts